
import { i18nText } from '@/locales';

import {Component, Watch, Vue} from "vue-property-decorator";
import {FiltersData} from "@/entity/filters/extFilter";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {mixins} from "vue-class-component";
import {FinanceOperationsTableMix} from "@/UI/mixins/Store/FinanceOperationsTableMix";
import {getStudioId} from "@/UI/lib/state";
import {ScrollData, SearchData} from "@/UI/Decorators/decorator";
import FinanceOperationComponent from "@/UI/pages/finance/components/FinanceOperationComponent.vue"
import {FinanceOperationForm} from "@/UI/pages/finance/lib/FinanceOperationForm"
import {FinanceOperationsStore} from "@/store/modules/Finance/FinanceOperations";
import {PaymentArticlesStore} from "@/store/modules/PaymentArticles";
import {CounterpartiesStore} from "@/store/modules/Counterparties";
import {WorkersStore} from "@/store/modules/Workers";
import {ClientsStore} from "@/store/modules/Clients";
import {Button, Menu, List, Table, Select} from "ant-design-vue";
import {FormModel, message} from "ant-design-vue";
import moment from 'moment';
import {checkUserRole, getUserData} from '@/router/Lib/helper';
import {FinanceOperationsAddFormRequestType} from "@/form/finance/finance_operations/FinanceOperationsAddForm.types";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";

@Component({
  components: {
    PageTitle,
    FinanceOperationComponent,
    BaseDataForm,
    FilterTableComponent,
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    SortComponent
  },
})

export default class FinanceOperations extends mixins(
    ProxyGetData,
    FinanceOperationsTableMix,
) {
  form = new FinanceOperationForm()
  filtersData = new FiltersData()
  financeOperation_type: any = [
    {label: i18nText("Не указано"), key: '0'},
    {label: i18nText("Расход"), key: "1"},
    {label: i18nText("Доход"), key: "2"}
  ]
  salon_id: number | null = getStudioId(this);
  showAddModal = false;
  send_type: number | null = null
  fileList: any = [];
  uploading = false;
  eternal_cashbox: any = []
  eternal_paymenArt: any = []

  sort(by: any, column: any) {
    if (column.dataIndex === 'sum') {
      column.dataIndex = 'amount'
    }
    this.sortedData(by, column)
  }

  @Watch("$store.state.salon_id", {immediate: false})
  async onStudioChange(): Promise<void> {
    this.formReady = false;
    this.table_load = true;
    this.salon_id = getStudioId(this);

    await this.fetchModules([
      {s: 'counterparties', p: {limit: -1, filter: {salon_id: this.salon_id}}},
      {s: 'paymentArticles', p: {limit: -1, filter: {salon_id: this.salon_id}}},
      {s: 'cashbox', p: {limit: -1, filter: {salon_id: this.salon_id}}},
      {s: 'clients', p: {filter: {salon_id: this.salon_id}}},
      {s: 'workers', p: {limit: -1, filter: {salon_id: this.salon_id}}}
    ])

    this.proxyFilter = {
      salon_id: this.salon_id
    }

    this.setFilters(this)

    await this.onApplyFilters();
    this.eternal_cashbox = this.cashboxes
    this.eternal_paymenArt = this.paymentArticles

    this.formReady = true;
  }

  async submitForm(): Promise<void> {
    let data: FinanceOperationsAddFormRequestType | any = {
      cashbox: this.form.cashbox,
      comment: this.form.comment,
      date: moment(this.form.date).format('DD.MM.YYYY'),
      paymentType: this.form.payment_article,
      salon_id: getStudioId(this),
      sum: this.form.sum,
      time: this.form.time,
      target: this.form.recipient,
      targetType: this.form.recipient_type,

      id: this.form.id
    }

    if (checkUserRole() === 'owner') {
      const userData = getUserData()
      data.salon_id = userData.studios
    } else if (this.$store.state.salon_id) {
      data.salon_id = this.$store.state.salon_id
    }

    ((this.$refs.financeForm as any).$refs.financeForm as FormModel).validate(async (valid) => {
      if (valid) {
        let isSuccess = false;
        if (this.send_type === 1) {
          const response = await FinanceOperationsStore.create(data as any);
          if (response && response.status) {
            isSuccess = true;
            message.success(i18nText("Финансовая операция успешно создана"));
          } else {
            message.error(response.response);
          }
        }
        if (this.send_type === 2) {
          isSuccess = true;
          const response = await FinanceOperationsStore.update(data as any)
          if (response && response.status) {
            isSuccess = true;
            message.success(i18nText("Финансовая операция успешно обновлена"))
          } else {
            message.error(response.response);
          }
        }

        if (isSuccess) {
          this.form = new FinanceOperationForm()
          this.showAddModal = false
          await this.sortedData('desc', {dataIndex: 'date'})
        }
      }
    })
  }

  newPayment() {
    this.form = new FinanceOperationForm()
    this.send_type = 1
    this.form.recipient_data = this.counterparties
    this.showAddModal = true
  }

  async updateFinance(record: any): Promise<void> {
    this.send_type = 2
    this.form = new FinanceOperationForm()
    if(!record.target?.data) {
      if(record.contractor.id) record.target.selected = record.contractor.id
      if(record.staff.id) record.target.selected = record.staff.id
      if(record.client.id) record.target.selected = record.client.id
    }
    this.form.setFormData(record)

    if (record.target !== null) {
      if (record.target.id === 1) {
        for (let i of this.counterparties) {
          if (i.id === record.contractor_id) {
            this.form.recipient = record.contractor_id
          }
            this.form.recipient_data.push(i)
        }
      }
      // if (record.target.id === 2 && this.form.recipient_data.length === 1) {
      if (record.target.id === 2) {
        for (let i of this.clients) {
          if (i.id === record.client_id) {
            this.form.recipient = record.client_id
          }
          this.form.recipient_data.push(i)
        }
      }
      if (record.target.id === 3) {
        for (let i of this.workers) {
          if (i.id === record.staff_id) {
            this.form.recipient = record.staff_id
          }
          this.form.recipient_data.push(i)
        }
      }
    } else {
      this.form.recipient_data = this.counterparties
    }

    if (PaymentArticlesStore.paymentArticles && PaymentArticlesStore.paymentArticles.data) {
      if (record.salon_id !== record.type.salon_id) {
        PaymentArticlesStore.paymentArticles.data = [record.type]
      } else {
        PaymentArticlesStore.paymentArticles.data = this.eternal_paymenArt;
      }
    }

    if (CashboxStore.items && CashboxStore.items.data) {
      if (record.salon_id !== record.type.salon_id) {
        CashboxStore.items.data = [record.cashbox];
      } else {
        CashboxStore.items.data = this.eternal_cashbox;
      }
    }

    this.showAddModal = true
  }

  showVisit(): void {
    alert(i18nText("В разработке"))
  }

  async created(): Promise<void> {
    try {
      await this.fetchModules([
        {s: 'counterparties', p: {limit: -1, filter: {salon_id: this.salon_id}}},
        {s: 'paymentArticles', p: {limit: -1, filter: {salon_id: this.salon_id}}},
        {s: 'cashbox', p: {limit: -1, filter: {salon_id: this.salon_id}}},
        {s: 'clients', p: {filter: {salon_id: this.salon_id}}},
        {s: 'workers', p: {limit: -1, filter: {salon_id: this.salon_id}}}
      ])
      this.proxyFilter = {
        salon_id: Vue.router.currentRoute.params.Studio
      }
      await this.sortedData('desc', {dataIndex: 'date'})

      this.setFilters(this)
      if (Vue.router.currentRoute.params.Data) {
        await this.updateFinance(Vue.router.currentRoute.params.Data)
      }

      this.eternal_cashbox = this.cashboxes
      this.eternal_paymenArt = this.paymentArticles
    } catch (e) {
      console.error(e);
    } finally {
      this.formReady = true;
      this.disabled_sort = true
    }
  }

  timer: any = 0

  @SearchData
  hSearch(source: any, value: any): void {
  }

  @ScrollData
  HScroll(source: any, filter: any): void {
  }

  handleScroll(source: any, filter: any): void {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.HScroll(source, filter)
    }, 500);
  }

  handleSearch(source: string, value: string): void {
    this.hSearch(source, value)
  }

  inDevelopment() {
    alert(i18nText("В разработке"))
  }

  get clients(): any {
    return ClientsStore.clients?.data
  }

  get paymentArticles(): any {
    return PaymentArticlesStore.paymentArticles?.data
  }

  get counterparties(): any {
    return CounterpartiesStore.counterparties?.data
  }

  get workers(): any {
    return WorkersStore.workers?.data
  }

  get financeOperations(): any {
    return FinanceOperationsStore.items?.data
  }

  get cashboxes(): any {
    return CashboxStore.items?.data
  }

  setFilters(that: any): void {
    this.filtersData.filters = [];
    this.filtersData.filters.push(
        {
          key: 0,
          type: "datetimerange",
          label: i18nText("Период"),
          async onChange(value: any) {
            let filter = {}
            if (value.length === 0) {
              filter = {
                date_from: '0',
                date_to: '0'
              }
            } else {
              filter = {
                date_from: value[0].format("DD.MM.YYYY"),
                date_to: value[1].format("DD.MM.YYYY")
              }
            }
            await that.filterData(filter)
          },
          async onScroll(e) {
          },
          async onFocus() {
          },
          async onSearch(e) {
          }
        },
        {
          key: 1,
          type: "sourceVuex",
          label: i18nText("Назначение"),
          default_value: [i18nText("Не указано")],
          vuexSource: "paymentArticles",
          storeVuexSource: "paymentArticles",
          async onChange(value: any) {
            await that.filterData({
              article_payment_id: value
            })
          },
          async onSearch(value: any) {
            await that.fetchModules([
              {
                s: 'paymentArticles', p: {
                  filter: {
                    name: value,
                    salon_id: getStudioId(this)
                  }
                }
              }
            ])
          },
          async onFocus() {
            await that.fetchModules([
              {
                s: 'paymentArticles', p: {
                  limit: -1,
                  filter: {
                    salon_id: getStudioId(this)
                  }
                }
              }
            ])
          },
          async onScroll(e) {
          },
        },
        {
          key: 2,
          type: "select",
          label: i18nText("Тип"),
          default_value: [i18nText("Не указано")],
          value: this.financeOperation_type,
          async onChange(value: any) {
            await that.filterData({
              type: value
            })
          },
          onSearch(value: any) {
            that.filtersData.filters[2].value = that.financeOperation_type.filter((t: any) => {
              return t.label.toLowerCase().indexOf(value) !== -1
            })
          },
          onFocus() {
            that.filtersData.filters[2].value = that.financeOperation_type
          },
          async onScroll(e) {
          },
        },
        {
          key: 3,
          type: "sourceVuex",
          label: i18nText("Касса"),
          vuexSource: "items",
          storeVuexSource: "cashbox",
          default_value: [i18nText("Не указано")],
          async onChange(value: any) {
            await that.filterData({
              cashbox_id: value
            })
          },
          async onSearch(value: any) {
            await that.handleSearch("cashbox", {name: value, salon_id: getStudioId(this)})
          },
          async onScroll(e) {
          },
          async onFocus() {
          }
        },
        {
          key: 4,
          type: "auto_complete",
          label: i18nText("Поиск по номеру клиента"),
          default_value: [i18nText("Не указано")],
          vuexSource: "clients",
          storeVuexSource: "clients",
          sel_op_first: i18nText("Имя: "),
          sel_op_second: i18nText("Тел.: "),
          async onSearch(value: string) {
            await that.handleSearch("clients", {
              phone: value,
              salon_id: getStudioId(this)
            })
          },
          async onChange(value: any) {
            let filter = {}
            if (!value) filter = {target_value: '0'}
            else if (value.length > 10) filter = {target_value: value.substr(0, 11)}
            await that.filterData(filter)
          },
          async onScroll() {
            that.handleScroll('clients', that.salon_id);
          },
          async onFocus() {
          }
        }
    )
    this.filter_load = true
  }
}
